export default "__VITE_ASSET__B7rxnLbJ__"